import { SVGAttributes } from 'react'

export const Desk = (props: SVGAttributes<SVGElement>) => (
  <svg {...props} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.033 29.1667L17.033 43.1667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8333 29.1667L43.6333 29.1667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.0331 33.3669H39.4331"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39.4331 29.1667L39.4331 43.1667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 24.18V15.22C21 14.9881 21.188 14.8 21.42 14.8H34.58C34.812 14.8 35 14.9881 35 15.22V24.18C35 24.412 34.812 24.6 34.58 24.6H21.42C21.188 24.6 21 24.412 21 24.18Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <line
      x1="27.875"
      y1="25.3501"
      x2="27.875"
      y2="27.3501"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <line
      x1="30.75"
      y1="27.6833"
      x2="25.25"
      y2="27.6833"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)
